import type { ValidationErrorMessage } from '@festina/life-general-types/life'
import { typeUtils } from '@festina-life/core'

/**
 * Checks whether the given error is an `ApiError` with body type of validation error.
 */
export const isValidationError = (
  error: Error,
): error is Error & { body: ValidationErrorMessage } =>
  error.name === 'ApiError' &&
  typeUtils.hasField(error, 'body') &&
  typeUtils.hasField(error.body, '_type') &&
  error.body._type === 'ValidationErrorMessage'
